module.exports = {
  PLUGIN_NAME: 'monitor'
};
